import { memo } from 'react';
import { FormProvider } from 'react-hook-form';
import ConditionalApprovals from '../conditional-approvals/conditional-approvals';
import { SectionContainer } from './styles';
import type { ConditionalApprovalsForm } from './types';

interface ConditionalApprovalsElementProps {
  form: ConditionalApprovalsForm;
}

const ConditionalApprovalsElement = ({
  form,
}: ConditionalApprovalsElementProps) => (
  <SectionContainer>
    <FormProvider {...form}>
      <ConditionalApprovals />
    </FormProvider>
  </SectionContainer>
);

export default memo(ConditionalApprovalsElement);
